import { styled } from "@mui/material";

export const LoadingMessage = styled('div')`
  display: grid;
  place-content: center;
  width: 100vw;
  height: 100vh;
  font-size: 1.4rem;
  font-weight: 500rem;
`;

LoadingMessage.displayName = 'LoadingMessage';
